import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatSqlForDisplay } from '../../utils/sqlFormat';
import './SqlSourceView.css';

const RAW_PREF_KEY = 'livesql_sqlview_raw';
const readRawPref = () => { try { return localStorage.getItem(RAW_PREF_KEY) === '1'; } catch (_e) { return false; } };
const writeRawPref = (v) => { try { localStorage.setItem(RAW_PREF_KEY, v ? '1' : '0'); } catch (_e) { /* 기억 못 해도 보인다 */ } };

/**
 * 「쿼리 보기」 공용 본문 — 자원·세션·SQL 성능·AWR 네 곳이 쓴다(2026-10-03).
 * 서버가 준 실제 SQL 을 **에디터 포맷과 같은 모양**으로 보이고, 「원문」 으로 받은 문자열 그대로도 볼 수 있다
 * (포매터가 바꾼 게 의심될 때 대조용). 포맷이 실패하면 원문을 보이고 그렇다고 말한다.
 * 오류 문구(error)는 SQL 이 아니므로 포매터에 넣지 않는다.
 */
export default function SqlSourceView({ sql, error, loadingText, className }) {
  const { t } = useTranslation();
  const [raw, setRaw] = useState(readRawPref);
  const formatted = useMemo(() => (typeof sql === 'string' ? formatSqlForDisplay(sql) : null), [sql]);

  if (error) return <pre className={className}>{error}</pre>;
  if (typeof sql !== 'string') return <pre className={className}>{loadingText}</pre>;

  const showRaw = raw || !formatted.ok;
  const toggle = () => { const next = !raw; setRaw(next); writeRawPref(next); };
  return (
    <div className="sql-source-view">
      <div className="sql-source-view-bar">
        {!formatted.ok && <span className="sql-source-view-warn" title={formatted.error || ''}>{t('monitoring:sqlView.formatFailed')}</span>}
        <span className="sql-source-view-mode">{showRaw ? t('monitoring:sqlView.rawMode') : t('monitoring:sqlView.formattedMode')}</span>
        <button type="button" className="sql-source-view-toggle" onClick={toggle} disabled={!formatted.ok}>
          {showRaw ? t('monitoring:sqlView.showFormatted') : t('monitoring:sqlView.showRaw')}
        </button>
      </div>
      <pre className={className}>{showRaw ? sql : formatted.text}</pre>
    </div>
  );
}
